import { Component, JSX } from 'solid-js';

export interface Header3Props {
    children: JSX.Element;
}

const Header3: Component<Header3Props> = (props) => {
    return (
        <h3 class=" text-secondary-white font-OpenSans text-base font-bold">
            {props.children}
        </h3>
    );
};

export default Header3;
